import React, { useState, useEffect } from 'react'
import axios from 'axios'
import {
  TextField
} from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { checkErrorStatus, setSnackbar } from 'utils/common/actions'
import { getIdArray } from 'helpers/dataHelpers'
import Autocomplete from '@material-ui/lab/Autocomplete'
import Config from 'config'


const IndustriesInput = (props) => {
  const {
    error,
    helperText,
    setValue,
    defaultValue,
    className,
    InputLabelProps,
    placeholder,
    single
  } = props
  const { apiUrl } = Config.network
  const dispatch = useDispatch()
  const [industries, setIndustries] = useState([])

  const getIndustries = () => {
    const url = `${apiUrl}industries/`
    axios.get(url).then((body) => {
      const { data } = body
      setIndustries(data)
    }).catch(error => {
      if (error.response) {
        dispatch(checkErrorStatus(error.response.status))
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }

  useEffect(() => {
    getIndustries()
    if (defaultValue) {
      if (!single) {
        setValue(getIdArray(defaultValue))
      } else {
        setValue(defaultValue)
      }
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (event, newValue) => {
    // setLocalValue(newValue)
    if (!single) {
      setValue(getIdArray(newValue))
    } else {
      setValue(newValue)
    }
  }

  const setDefaultValue = () => {
    if (defaultValue) {
      return defaultValue
    }
    if (single) {
      return null
    }
    return []
  }

  return (
    <Autocomplete
      className={className}
      getOptionSelected={(option, value) => option.id === value.id}
      onChange={handleChange}
      multiple={!single}
      defaultValue={setDefaultValue()}
      filterSelectedOptions
      options={industries}
      autoHighlight
      fullWidth
      getOptionLabel={(industry) => industry.name}
      renderOption={(industry) => (
        <React.Fragment>
          {industry.name}
        </React.Fragment>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label='Industry'
          variant='outlined'
          fullWidth
          required
          error={error}
          helperText={helperText}
          name='industry'
          InputLabelProps={InputLabelProps}
          color='secondary'
          placeholder={placeholder || 'Select industries...'}
        />
      )}
    />
  )
}

export default IndustriesInput
